
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticPropsResult } from 'next';
import dynamic from 'next/dynamic';
import useLocale from 'next-translate/useTranslation';
import { useMemo } from 'react';
import { Product } from 'types';
import { getActiveProductsWithPrices } from '@/data/products';
import Footer from '@/components/layout/Footer';
import LandingPageNavigation from '@/components/layout/LandingPageNavigation';
import Seo from '@/components/Seo';
import { HAS_FREE_PLAN } from '@/constants/common';
const PricingForLandingPage = dynamic(() => import('@/components/PricingForLandingPage'));
const Faq = dynamic(() => import('@/components/Faq'));
const CallToAction = dynamic(() => import('@/components/CallToAction'));
interface Props {
    products: Product[];
    isStaticPage?: boolean;
}
export default function PricingPage({ products }: Props) {
    const { t } = useLocale('pricing');
    // Memoize filtered products to prevent re-computation on every render
    const filteredProducts = useMemo(() => products.filter((plan) => HAS_FREE_PLAN || plan.name !== 'Free'), [products]);
    return (<main className='bg-[#0B0F19] relative min-h-screen'>
      {/* Background glow effects - hidden on mobile for performance */}
      <div className='hidden md:block fixed inset-0 z-0 pointer-events-none overflow-hidden'>
        <div className='absolute top-[-20%] left-[-10%] w-[50%] h-[50%] rounded-full bg-purple-600/5 blur-[120px]'/>
        <div className='absolute bottom-[-20%] right-[-10%] w-[50%] h-[50%] rounded-full bg-indigo-600/5 blur-[120px]'/>
      </div>
      <div className='relative z-10'>
        <Seo templateTitle={t('Pricing Plans')} title={t('Pricing Plans')} description={t('Simple, transparent pricing for Easy-Peasy.AI. Start a free trial and unlock AI writing, image, video, audio and chat tools. Cancel anytime with a 30-day money-back guarantee.')} image='https://media.easy-peasy.ai/assets/placeholder_home_page.jpeg' products={products} page='other'/>
        <div className='relative z-50'>
          <LandingPageNavigation variant='light' skipUserContext forceDark/>
        </div>
        <PricingForLandingPage isUpgrade={true} hideLowerPrices={false} products={filteredProducts}/>
        <div className='dark'>
          <Faq />
          <CallToAction />
          <Footer variant='dark'/>
        </div>
      </div>
    </main>);
}
async function getStaticProps(): Promise<GetStaticPropsResult<Props>> {
    const products = await getActiveProductsWithPrices();
    return {
        props: {
            products,
            // Enable lightweight _app.tsx render path that skips MyUserContextProvider
            isStaticPage: true,
        },
        revalidate: 60,
    };
}

    async function __Next_Translate__getStaticProps__1a167d9f4ba__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/pricing',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a167d9f4ba__ as getStaticProps }
  